import _ from 'lodash'
// TODO:: This is temporary fix to convert all attributes to camelcase
// till the API adapter is ready
export const camelize = obj => _.transform(obj, (acc, value, key, target) => {
    const camelKey = _.isArray(target) ? key : _.camelCase(key)

    acc[camelKey] = _.isObject(value) ? camelize(value) : value
})
